import { MutableRefObject, ReactNode, RefObject } from "react";

export const formatData = (array: Array<{ id: string; node: ReactNode }>) => {
    const clone = array.map((item) => ({
        ...item,
        id: `clone${item.id}`,
    }));

    return [...array, ...clone];
};

export const keyframeTypes = {
    main: "main",
    initial: "initial",
    secondary: "secondary",
} as const;

export const calcInitialFrame = (elemRef: RefObject<HTMLDivElement>) => {
    const width = elemRef.current?.offsetWidth;

    return [
        {
            transform: `translateX(-${width}px)`,
        },
        { transform: "translateX(-100%)" },
    ];
};

const keyFrames = {
    main: [{ transform: "translateX(0)" }, { transform: `translateX(-100%)` }],
    secondary: [{ transform: "translateX(-100%)" }, { transform: "translateX(-180%)" }],
};

export const calcOptions = (
    type: keyof typeof keyframeTypes,
    duration: number,
    elemRef: RefObject<HTMLDivElement>,
    containerRef: RefObject<HTMLDivElement> | null = null,
): { duration: number; fill: FillMode } => {
    const width = elemRef.current?.offsetWidth ?? 0;
    const pixelsCount = 10;
    const secondaryPathPercent = 0.8;

    if (type === keyframeTypes.main) {
        return { duration: (width / pixelsCount) * duration, fill: "both" };
    }

    if (type === keyframeTypes.initial && containerRef) {
        const containerWidth = containerRef.current?.offsetWidth ?? 0;

        return {
            duration: ((width - containerWidth) / pixelsCount) * duration,
            fill: "both",
        };
    }

    return {
        duration: (width / pixelsCount) * secondaryPathPercent * duration,
        fill: "both",
    };
};

export const handleFinish = (
    mainElement: RefObject<HTMLDivElement>,
    secondaryElement: RefObject<HTMLDivElement>,
    firstRef: MutableRefObject<Animation | void>,
    secondRef: MutableRefObject<Animation | void | null>,
    duration: number,
) => {
    const first = firstRef;
    const second = secondRef;

    first.current = mainElement.current?.animate(
        keyFrames[keyframeTypes.main],
        calcOptions(keyframeTypes.main, duration, mainElement),
    );

    if (first.current) {
        first.current.onfinish = () => handleFinish(secondaryElement, mainElement, first, second, duration);
    }

    second.current = secondaryElement.current?.animate(
        keyFrames[keyframeTypes.secondary],
        calcOptions(keyframeTypes.secondary, duration, secondaryElement),
    );

    if (second.current) {
        second.current.onfinish = () => {
            second.current = null;
        };
    }
};
